import { Box, Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { FONT_SIZE, INK } from "../../../../theme/tokens";
import type { DayStats } from "../../../../utils/models";
import { formatNumber } from "../../../../utils/utilFunctions";
import type { GapsDayHppd } from "../useGapsDayModel";

type Props = { dayStats: DayStats; dayHppd: GapsDayHppd };

/** `54 census · 2.94 hppd` — the day's two clinical numbers, figures emphasised and units quiet. */
export const GapsCensusAndHppd: FC<Props> = ({ dayStats, dayHppd }) => {
	const { t } = useTranslation();
	return (
		<Typography component="span" sx={{ flex: "none", fontSize: FONT_SIZE.LABEL_SM, color: INK.MUTED, fontVariantNumeric: "tabular-nums" }}>
			<Box component="span" sx={{ fontWeight: 600, color: INK.PRIMARY }}>
				{dayStats.census}
			</Box>{" "}
			{t("gaps.metrics.census")} ·{" "}
			<Box component="span" sx={{ fontWeight: 600, color: INK.PRIMARY }}>
				{formatNumber(dayHppd.hppd)}
			</Box>{" "}
			{t("gaps.metrics.hppd")}
		</Typography>
	);
};
